import { Suggestion } from 'types/suggestions';
import { patchUrlByLocale } from 'utils';
import { capitalize } from 'utils/capitalize';

export const getHistoryItemTitle = (value: string, suggestion: Suggestion | null) => {
  if (!suggestion) {
    return value;
  }
  if (
    'categoryUrl' in suggestion &&
    'serviceName' in suggestion &&
    suggestion.categoryUrl &&
    suggestion.serviceName
  ) {
    return capitalize(suggestion.serviceName);
  }
  if ('name' in suggestion && suggestion.name) {
    return suggestion.name;
  }
  return value;
};

export const getHistoryItemUrl = (sanitizedValue: string, suggestion: Suggestion | null) => {
  if (!suggestion) {
    return patchUrlByLocale({ url: `/search/?q=${sanitizedValue}` });
  }
  if (
    'categoryUrl' in suggestion &&
    'serviceName' in suggestion &&
    suggestion.categoryUrl &&
    suggestion.serviceName
  ) {
    return patchUrlByLocale({ url: suggestion.categoryUrl });
  }
  if ('pageUrl' in suggestion && suggestion.pageUrl) {
    return patchUrlByLocale({ url: suggestion.pageUrl });
  }
  return patchUrlByLocale({ url: `/search/?q=${sanitizedValue}&suggest=true` });
};
